import auth0 from 'auth0-js'
import store from '@/store'
import api from '@/lib/api'
import {AlertMessages, LocalStorage} from '@/lib/definitions'

let tokenExp = null
const allowedDays = 3 * 24 * 60 * 60 * 1000 // 3 days in ms

const auth = {}
const options = {
  redirectUri:
    process.env.VUE_APP_DOMAIN + 'static/auth0-iframe-validation.html',
  scope: 'openid',
  usePostMessage: true,
  postMessageDataType: 'auth0:silent-authentication',
  nonce: ''
}

auth.init = async () => {
  auth.auth0 = new auth0.WebAuth({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientID: process.env.VUE_APP_AUTH0_CLIENT_ID,
    redirectUri: process.env.VUE_APP_DOMAIN + 'validate',
    responseType: 'token',
    state: 'renew'
  })
  tokenExp = localStorage.getItem(LocalStorage.TOKEN_EXP)
  if (!tokenExp) {
    return Promise.resolve()
  } else {
    if (isTokenOlderThanAllowedDays()) {
      auth.logout(AlertMessages.TOKEN_EXPIRED)
    } else {
      await auth.renewToken()
      await auth.login()
    }
  }
}

auth.login = auth0Result => {
  if (auth0Result) saveCredentials(auth0Result)
  return store.dispatch('login')
}

auth.logout = (msg = null) => {
  // Make sure no Object is saved in LocalStorage (alert [object Object])
  if (msg === Object(msg)) {
    msg = msg.errorDescription || msg.error_description || msg.error || null
  }
  if (msg) {
    localStorage.setItem(LocalStorage.PENDING_MESSAGE, msg)
  }
  store.dispatch('logout')
  localStorage.removeItem(LocalStorage.TOKEN_EXP)
  // Force Auth0 logout (https://auth0.com/docs/logout)
  window.location = `${process.env.VUE_APP_AUTH0_LOGOUT}${process.env.VUE_APP_DOMAIN}&client_id=${process.env.VUE_APP_AUTH0_CLIENT_ID}`
}

auth.checkToken = async () => {
  if (!isTokenExpired()) {
    return Promise.resolve()
  } else {
    if (isTokenOlderThanAllowedDays()) {
      auth.logout(AlertMessages.TOKEN_EXPIRED)
    } else {
      // Token expired, but not 3 days old
      await auth.renewToken()
    }
  }
}

auth.renewToken = async () => {
  return new Promise((resolve, reject) => {
    options.nonce = randomString(16)
    auth.auth0.checkSession(options, (err, res) => {
      if (res) {
        console.groupCollapsed('renewAuth ok')
        console.log(res)
        console.groupEnd()
        saveCredentials(res)
        resolve()
      } else {
        reject(err)
        console.error(err)
      }
    })
  })
}

function saveCredentials({idToken, idTokenPayload: {exp}}) {
  api.setAuthToken(idToken)
  tokenExp = exp
  localStorage.setItem(LocalStorage.TOKEN_EXP, exp)
}

function isTokenOlderThanAllowedDays() {
  return tokenLifeSpan() < -allowedDays // Token expired more than 3 days ago ?
}

function isTokenExpired() {
  return tokenLifeSpan() < 3000 // 3000 ms = api request window
}

function tokenLifeSpan() {
  return new Date(tokenExp * 1000) - new Date()
}

// Helpers
function randomString(length) {
  // https://github.com/auth0/auth0.js/issues/429
  const bytes = new Uint8Array(length)
  const random = window.crypto.getRandomValues(bytes)
  const result = []
  const charset =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~'
  Array.prototype.forEach.call(random, c => {
    result.push(charset[c % charset.length])
  })
  return result.join('')
}

export default auth
